import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LocalserviceService } from 'src/app/helpers/services/localservice.service';


@Component({
  selector: 'app-shared-alert-model',
  templateUrl: './shared-alert-model.component.html',
  styleUrls: ['./shared-alert-model.component.css']
})
export class SharedAlertModelComponent implements OnInit {
  modelObject: any;

  constructor(
    public dialogRef: MatDialogRef<SharedAlertModelComponent>,
    @Inject(MAT_DIALOG_DATA) modalData: any,
    private localService: LocalserviceService
  ) {
    console.log(modalData);
    this.modelObject = modalData
  }



  ngOnInit() {


  }

  // When the user clicks the action button, the modal calls the service\
  // responsible for executing the action for this modal (depending on\
  // the name passed to `modalData`). After that, it closes the modal
  actionFunction() {
    //this.modalService.modalAction(this.modalData);

    this.closeModal();
    setTimeout(() => {
      this.localService.OnCkcickOfSuccessButton("Successsssssss");
    }, 500);

  }

  // If the user clicks the cancel button a.k.a. the go back button, then\
  // just close the modal
  closeModal() {
    this.dialogRef.close();
    setTimeout(() => {
      this.localService.OnCkcickOfFailureButton("failure");
    }, 500);
  }



}
